module.exports = "https://tutorchat.chegg.com/static/media/ic-unpin.fca9dcd8.svg";